import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidebarIconReports = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M182.857 54.857C182.857 24.571 207.429 0 237.714 0h36.572c30.285 0 54.857 24.571 54.857 54.857v402.286c0 30.286-24.572 54.857-54.857 54.857h-36.572c-30.285 0-54.857-24.571-54.857-54.857V54.857ZM0 274.286C0 244 24.571 219.429 54.857 219.429H91.43c30.285 0 54.857 24.571 54.857 54.857v182.857c0 30.286-24.572 54.857-54.857 54.857H54.857C24.571 512 0 487.429 0 457.143V274.286ZM420.571 73.143h36.572C487.429 73.143 512 97.714 512 128v329.143C512 487.429 487.429 512 457.143 512h-36.572c-30.285 0-54.857-24.571-54.857-54.857V128c0-30.286 24.572-54.857 54.857-54.857Z"
	})
});
export default SvgSidebarIconReports;
